import { LayerFactValue, MAP_LAYER_FACTS, MapRastersFact } from '@/api/rest/resources/types/fact';
import { useIsFactInPurchasedIndicatorProducts } from '@/hooks/useIsFactInPurchasedIndicatorProducts';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';
import { isNullish } from '@/utils/booleans';

export const useHasHabitatIntactnessData = () => {
  const isSubscribedToHabitatIntactnessIndicatorProduct = useIsFactInPurchasedIndicatorProducts(
    MAP_LAYER_FACTS.habitat_intactness_raster_urls,
  );
  const hiRasterFacts = usePlotFacts<MapRastersFact>([MAP_LAYER_FACTS.habitat_intactness_raster_urls]);
  const hasHabitatIntactnessData = !isNullish(
    getFactFromFactArray<LayerFactValue>(hiRasterFacts, MAP_LAYER_FACTS.habitat_intactness_raster_urls)?.value,
  );

  return isSubscribedToHabitatIntactnessIndicatorProduct && hasHabitatIntactnessData;
};
